const attributes = {
    aria: {
        describedBy: 'aria-describedby',
        disabled: 'aria-disabled',
        expanded: 'aria-expanded',
        hidden: 'aria-hidden',
        labelledBy: 'aria-labelledby',
    },
    css: {
        //dom: {
        //    disabled: 'disabled',
        //},
        class: {
            disabled: 'disabled',
            displayNone: 'display-none',
            activeTab: 'tab-item--active',
            expanded: 'expanded'
        }
    },
    events: {
        blur: 'blur',
        change: 'change',
        click: 'click',
        dragend: 'dragend',
        focus: 'focus',
        keydown: 'keydown',
        keyup: 'keyup',
        load: 'load',
        mouseleave: 'mouseleave',
        mouseout: 'mouseout',
        mouseover: 'mouseover',
        mousewheel: 'mousewheel',
        mousedown: 'mousedown',
        move: 'move',
        moveend: 'moveend',
        movestart: 'movestart',
        remove: 'remove',
        touchcancel: 'touchcancel',
        touchend: 'touchend',
        touchmove: 'touchmove',
        touchstart: 'touchstart',
        zoomend: 'zoomend'
    },
    //culture: {
    //    english: 'en-GB',
    //    welsh: 'en-CY'
    //},
    global: {
        false: 'false',
        true: 'true'
    }
}

export default attributes;
